import Fuse from 'fuse.js';

const mealPart = [
    'Breakfast',
    'Lunch',
    'Dinner',
    'Food',
    'Meal',
    'Sunset',
    'Sunrise',
    'Bedtime',
    'Tea',
    'Milk',
    'Coffee',
];

const staticAbbr = [
    'Morning and Night',
    'Morning and Afternoon',
    'Afternoon and Night',
    'Empty Stomach',
    'BBF',
    'ABF',
    'BD',
    'AD',
    'ABF AD',
    'ABF BD',
    'BBF ABF',
    'BD AD',
    'BBF AD',
    'BBF BD',
    'BBF BD',
    'BBF BD AD',
    'BBF ABF AD',
    'BBF ABF BD',
    'BBF ABF BD AD',
];

const map: { [k: string]: string[] } = {
    After: [
        ...mealPart,
        'Defecation',
        'Hairwash',
        'Wash',
        'Facewash',
        'Gargle',
        'Brush',
        'Motion',
        'Moisturizer',
        'Stool',
        'Dialysis',
        'Feed',
        'Supper',
        'Bath',
        'Exercise',
        'Coitus',

        'Sex',
        'Urination',
        'Sleep',
        'Breastfeed',
        'Toilet',
        'Snack',

        'Intercourse',
        'Activity',

        'Surgery',
        'Feed',
        'Travel',
    ],

    Before: [
        ...mealPart,
        'Defecation',
        'Hairwash',
        'Wash',
        'Facewash',
        'Gargle',
        'Brush',
        'Motion',
        'Moisturizer',
        'Stool',
        'Dialysis',
        'Feed',
        'Supper',
        'Bath',
        'Exercise',
        'Coitus',

        'Sex',
        'Urination',
        'Sleep',
        'Breastfeed',
        'Toilet',
        'Snack',

        'Intercourse',
        'Activity',

        'Surgery',
        'Feed',
        'Travel',
    ],

    With: [...mealPart, 'Water', 'Steroid', 'Snack', 'Honey', 'Water', 'Curd', 'Bath'],

    At: [...mealPart, 'Night', 'Morning', 'Anytime'],

    For: [
        'Gargle',
        'Appetite',
        'Dryness',
        'Acidity',
        'Bath',
        'Pain',
        'Steam',
        'Allergy',
        'Headache',
        'Anxiety',
        'Wash',
        'Nausea',
        'Nebulisation',
        'Checkup',
    ],

    During: [
        ...mealPart,
        'Attack',
        'Hairwash',
        'Bath',
        'Pain',
        'Headache',
        'Facewash',
        'Sleep',
        'Wheeze',
        'Day',
        'Dialysis',
        'Daytime',
        'Fever',
    ],

    Between: mealPart,

    If: ['Acidity', 'Vomitting', 'Pain', 'Headache', 'Giddiness', 'Dizziness', 'Fever', 'Bleeding'],

    As: ['Shampoo', 'Meal', 'Moisturizer'],

    // In: ['water', 'night', 'morning', 'day', 'b/w', 'ear', 'eye', 'dinner'],

    By: ['Rotacap'],

    Per: ['Vagina', 'Rectal'],

    Under: ['Tongue'],
    // On: [
    //     'shoulder',
    //     'sunday',
    //     'face',
    //     'rash',
    //     'leg',
    //     'hair',
    //     'tuesday',
    //     'forearm',
    //     'body',
    //     'alternate',
    //     'scalp',
    //     'fifthday',
    //     'elbow',
    //     'neck',
    // ],
    Over: ['Night'],
    While: ['Defecation', 'Sitz Bath'],
};

// combine key of map with values against it and add to staticAbbr
Object.keys(map).forEach((key) =>
    map[key].forEach((item: string) => staticAbbr.push(`${key} ${item}`)),
);

const fuseConfig = {
    threshold: 0.1,
};

const generativeFuseConfig = {
    threshold: 0.4,
};

const staticFuse = new Fuse(staticAbbr, fuseConfig);

const timeSuffix = ['am', 'pm', 'hourly'];

const suffix = [
    'mins BBF',
    'mins ABF',
    'mins BD',
    'mins AD',
    'mins ABF AD',
    'mins ABF BD',
    'mins BBF ABF',
    'mins BD AD',
    'mins BBF AD',
    'mins BBF BD',
    'mins BBF BD AD',
    'mins BBF ABF AD',
    'mins BBF ABF BD',
    'mins BBF ABF BD AD',
];

export const onTimingSearch = async (text: string, genie_timings: string[]): Promise<string[]> => {
    if (!text.trim()) {
        return new Promise((resolve, _) => {
            const loweredText = text.toLowerCase();
            const options = genie_timings
                .filter((t) => t.toLowerCase().includes(loweredText))
                .map((t) => t);
            if (text && !options.find((t) => t.toLowerCase() === loweredText)) {
                options.push(text);
            }
            resolve(options);
        });
    }

    const allOptions: string[] = [];

    if (!isNaN(parseInt(text)) && parseInt(text) === 12) {
        allOptions.push(...['noon'].map((s) => `${parseInt(text)} ${s}`));
    }

    if (!isNaN(parseInt(text)) && parseInt(text) <= 12) {
        allOptions.push(...timeSuffix.map((s) => `${parseInt(text)} ${s}`));
    }

    if (!isNaN(parseInt(text))) {
        allOptions.push(...suffix.map((s) => `${parseInt(text)} ${s}`));
    }

    const isStaticAbbr = staticFuse.search(text);
    if (isStaticAbbr && isStaticAbbr.length) {
        allOptions.push(...isStaticAbbr.map((t) => t.item));
    }

    return new Promise((resolve, _) => {
        const allOptionsFuse = new Fuse(allOptions, generativeFuseConfig);
        const searchedOptions = allOptionsFuse.search(text).map((t) => t.item);
        if (
            !searchedOptions.find((opitem) => opitem.toLowerCase().startsWith(text.toLowerCase()))
        ) {
            searchedOptions.push(text);
        }
        resolve(searchedOptions);
    });
};
